// Get DOM elements
const button = document.getElementById('supplement-facts-btn');
const overlay = document.getElementById('supplement-facts-overlay');
const popup = document.getElementById('supplement-facts-popup');
const closeBtn = document.getElementById('supplement-facts-close');

// Open popup function
function openPopup() {
    overlay.classList.add('active');
    popup.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
}

// Close popup function
function closePopup() {
    overlay.classList.remove('active');
    popup.classList.remove('active');
    document.body.style.overflow = ''; // Enable scrolling
}

// Event listeners
button.addEventListener('click', openPopup);
closeBtn.addEventListener('click', closePopup);
overlay.addEventListener('click', closePopup);

// Close on escape key
document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
        closePopup();
    }
});